// removed by extract-text-webpack-plugin
module.exports = {"textarea":"FormTextarea__textarea___1SFXf"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Form/Textarea/FormTextarea.scss
// module id = 1227
// module chunks = 1